/* Ferme UGC video carousel. Initialises every [data-ferme-ugc] section on the
   page. Moved out of the section file so the section stays small enough to edit
   through the Admin API, and so the script is cached rather than inlined twice. */
(function () {
  function init(root) {
    if (!root || root.dataset.fermeInit) return;
    root.dataset.fermeInit = 'true';

    var stage = root.querySelector('.ferme-ugc__stage');
    var viewport = root.querySelector('.ferme-ugc__viewport');
    var track = root.querySelector('.ferme-ugc__track');
    var prevBtn = root.querySelector('.ferme-ugc__arrow--prev');
    var nextBtn = root.querySelector('.ferme-ugc__arrow--next');
    if (!track || !track.children.length) return;

    var interval = parseInt(root.dataset.interval, 10) || 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null, paused = false, sectionVisible = true, animating = false;

    function cardEls() { return Array.prototype.slice.call(track.children); }
    function total() { return track.children.length; }
    function reflow() { void track.offsetWidth; }
    function setX(px) { track.style.transform = 'translate3d(' + px + 'px,0,0)'; }
    function setAnim(on) { track.style.transition = on ? '' : 'none'; }

    function forceMuted(vid) {
      if (!vid) return;
      vid.muted = true;
      vid.defaultMuted = true;
      vid.volume = 0;
    }

    function safePlay(vid) {
      if (!vid) return;
      forceMuted(vid);
      var p = vid.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function stepSize() {
      var c = track.children;
      if (c.length > 1) {
        var d = c[1].offsetLeft - c[0].offsetLeft;
        if (d > 0) return d;
      }
      return c[0] ? c[0].offsetWidth : 0;
    }

    function perView() {
      var s = stepSize();
      if (!s || !viewport.clientWidth) return 1;
      return Math.min(total(), Math.max(1, Math.round(viewport.clientWidth / s)));
    }

    function updatePlayback(lookahead) {
      var limit = perView() + (lookahead || 0);
      cardEls().forEach(function (c, i) {
        var vid = c.querySelector('video');
        if (!vid) return;
        var on = sectionVisible && i < limit;
        vid.dataset.fermeInView = on ? 'true' : 'false';
        if (on) safePlay(vid); else vid.pause();
      });
    }

    function syncArrows() {
      var many = total() > perView();
      if (prevBtn) prevBtn.hidden = !many;
      if (nextBtn) nextBtn.hidden = !many;
    }

    function afterTransition(fn) {
      var done = false;
      function finish(e) {
        if (e && e.target !== track) return;
        if (done) return;
        done = true;
        track.removeEventListener('transitionend', finish);
        fn();
      }
      track.addEventListener('transitionend', finish);
      setTimeout(finish, 800);
    }

    function settle() {
      setAnim(false);
      setX(0);
      reflow();
      updatePlayback();
      animating = false;
    }

    function slide(dir) {
      if (animating) return;
      if (total() <= perView()) return;
      var s = stepSize();
      if (!s) return;
      animating = true;

      if (dir > 0) {
        updatePlayback(1);
        if (reduceMotion) {
          track.appendChild(track.firstElementChild);
          settle();
          return;
        }
        setAnim(true);
        reflow();
        setX(-s);
        afterTransition(function () {
          setAnim(false);
          track.appendChild(track.firstElementChild);
          settle();
        });
      } else {
        setAnim(false);
        track.insertBefore(track.lastElementChild, track.firstElementChild);
        setX(-s);
        reflow();
        updatePlayback(1);
        if (reduceMotion) {
          settle();
          return;
        }
        setAnim(true);
        reflow();
        setX(0);
        afterTransition(function () { settle(); });
      }
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    function start() {
      stop();
      if (reduceMotion || interval <= 0 || total() <= perView()) return;
      timer = setInterval(function () {
        if (paused || !sectionVisible) return;
        slide(1);
      }, interval);
    }

    cardEls().forEach(function (c) {
      var vid = c.querySelector('video');
      if (!vid) return;
      forceMuted(vid);
      vid.removeAttribute('controls');
      vid.addEventListener('volumechange', function () {
        if (!vid.muted || vid.volume > 0) forceMuted(vid);
      });
      vid.addEventListener('pause', function () {
        if (vid.dataset.fermeInView === 'true' && !vid.ended) safePlay(vid);
      });
      vid.addEventListener('ended', function () {
        vid.currentTime = 0;
        safePlay(vid);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { slide(-1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { slide(1); start(); });

    if (stage) {
      stage.addEventListener('mouseenter', function () { paused = true; });
      stage.addEventListener('mouseleave', function () { paused = false; });
      stage.addEventListener('focusin', function () { paused = true; });
      stage.addEventListener('focusout', function () { paused = false; });
    }

    var swipeX = null;
    viewport.addEventListener('touchstart', function (e) {
      swipeX = e.touches[0].clientX;
      paused = true;
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (swipeX === null) return;
      var dx = e.changedTouches[0].clientX - swipeX;
      if (Math.abs(dx) > 40) { slide(dx < 0 ? 1 : -1); start(); }
      swipeX = null;
      paused = false;
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sectionVisible = entry.isIntersecting;
          updatePlayback();
        });
      }, { threshold: 0.15 });
      observer.observe(root);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setAnim(false);
        setX(0);
        reflow();
        syncArrows();
        updatePlayback();
        start();
      }, 150);
    });

    setAnim(false);
    setX(0);
    reflow();
    syncArrows();
    updatePlayback();
    start();
  }

  function boot() {
    document.querySelectorAll('[data-ferme-ugc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
